<template>
    <div :class="className" :style="{height:eHeight,width:width}" />
</template>
<script>
import * as echarts from 'echarts'
require('echarts/theme/macarons') // echarts theme
import resize from './mixins/resize'

export default {
    mixins: [resize],
    props: {
        className: {
            type: String,
            default: 'chart'
        },
        width: {
            type: String,
            default: '100%'
        },
        eHeight: {
            type: String,
            default: '100%'
        },
        autoResize: {
            type: Boolean,
            default: true
        },
        baseLineData: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            chart: null
        }
    },
    watch: {
        baseLineData: {
            deep: true,
            handler(val) {
                this.setOptions(val)
            }
        }
    },
    mounted() {
        this.$nextTick(() => {
            this.initChart()
        })
    },
    beforeDestroy() {
        if (!this.chart) {
            return
        }
        this.chart.dispose()
        this.chart = null
    },
    methods: {
        initChart() {
            this.chart = echarts.init(this.$el, 'macarons')
            this.setOptions(this.baseLineData || {})
        },
        setOptions(data) {
            let _this = this;
            let setOptionStyle = {
                grid: {
                    left: '5%',
                    right: '2%'
                },
                tooltip: {
                  backgroundColor:'rgba(255,255,255,1)'
                },
                xAxis: {
                    type: 'category',
                    boundaryGap: false,
                    data: ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: false
                    }
                },
                yAxis: {
                    type: 'value',
                    axisLine: {
                        show: false
                    },
                    axisTick: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    splitArea: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    }
                },
                series: [{
                    data: [8, 932, 901, 934, 1290, 1330, 120],
                    type: 'line',
                    symbol: 'none',
                    areaStyle: {
                        color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                                offset: 0,
                                color: '#7051dd'
                            },
                            {
                                offset: 1,
                                color: _this.isbig ? '#203a90' : '#7051dd'
                            }
                        ])
                        // color: _this.isbig ? '#7051dd' : '#9660e4',
                        // opacity: 1
                    },
                    lineStyle: {
                        color: _this.isbig ? '#7051dd' : '#9660e4',
                    }

                }]
            }
            setOptionStyle.series[0].data = data;
            this.chart.setOption(setOptionStyle)
        }
    }
}

</script>
